import { action, makeObservable } from 'mobx';
import { createContext, useContext } from 'react';
import { QuoteRouteV2Id, RouteV2Id } from 'routes/routesConfigV2';
import { redirectToRoute } from 'routes/redirectToRoute';
import IGroupCensusReviewPageStore from 'store/modules/census/group-based/iGroupCensusReviewPageStore';
import QuoteFlowDelegate from 'store/flows/quote/quoteFlowDelegate';

interface DomainProps {
  groupId: string;
  enrollmentPeriodId: string;
  cartId: string;
}
export default class IMQCensusReviewPageStore extends IGroupCensusReviewPageStore {
  protected _domainData;
  private _cartId: string;
  public readonly flowDelegate: QuoteFlowDelegate;

  public onBackRedirect(): void {
    redirectToRoute(RouteV2Id.IMQ_ADD_EMPLOYEES_CENSUS_UPLOAD, {
      groupId: this._domainData.groupId,
      periodId: this._domainData.enrollmentPeriodId,
      cartId: this._cartId,
    });
  }

  public onCompleteRedirect(): void {
    redirectToRoute(RouteV2Id.IMQ_ADD_EMPLOYEES, {
      groupId: this._domainData.groupId,
      periodId: this._domainData.enrollmentPeriodId,
      cartId: this._cartId,
    });
  }

  constructor(domainData: DomainProps) {
    super();

    this._domainData = domainData;
    this._cartId = domainData.cartId;
    this.flowDelegate = new QuoteFlowDelegate({
      domainParams: {
        groupId: domainData.groupId,
        periodId: domainData.enrollmentPeriodId,
        cartId: domainData.cartId,
      },
      nextPageId: QuoteRouteV2Id.IMQ_ADD_EMPLOYEES,
    });
    makeObservable<IMQCensusReviewPageStore>(this, {
      onBackRedirect: action.bound,
      onCompleteRedirect: action.bound,
    });
  }
}

const IMQCensusReviewPageStoreContext = createContext(new IMQCensusReviewPageStore({} as DomainProps));

export const useIMQCensusReviewPageStore = (): IMQCensusReviewPageStore => {
  return useContext(IMQCensusReviewPageStoreContext);
};

export { IMQCensusReviewPageStoreContext };
